/* Project Import will be here */
import { getErrorObject, errorToast } from "utilities/utils";
import { getSurveyListApi, getSurveyDetailsApi, submitSurveyApi } from "services/survey/survey";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
import { getSurveyNotificationApi } from "services/survey/survey";
import { orderBy } from "lodash";
/* Project Import will be here */

export const types = {
    SURVEY_LIST_REQUEST: "survey/SURVEY_LIST_REQUEST",
    SURVEY_LIST_SUCCESS: "survey/SURVEY_LIST_SUCCESS",
    SURVEY_LIST_FAILURE: "survey/SURVEY_LIST_FAILURE",
    SURVEY_DETAILS_REQUEST: "survey/SURVEY_DETAILS_REQUEST",
    SURVEY_DETAILS_SUCCESS: "survey/SURVEY_DETAILS_SUCCESS",
    SURVEY_DETAILS_FAILURE: "survey/SURVEY_DETAILS_FAILURE",
    SURVEY_SUBMIT: "survey/SURVEY_SUBMIT",
    SURVEY_NOTIFICATION: "survey/SURVEY_NOTIFICATION"
};

const initialState = {
    list: {
        data: [],
        isLoading: false,
        error: null
    },
    details: {
        data: {},
        isLoading: false,
        error: null
    },
    submittingSurvey: false,
    surveyNotification: {
        data: []
    }
};

export const survey = (state = initialState, action) => {
    switch (action.type) {
        case types.SURVEY_LIST_REQUEST: {
            return {
                ...state,
                list: {
                    ...state.list,
                    isLoading: true
                }
            };
        }

        case types.SURVEY_LIST_SUCCESS: {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.payload,
                    isLoading: false,
                    error: null
                }
            };
        }

        case types.SURVEY_LIST_FAILURE: {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.payload,
                    data: [],
                    isLoading: false
                }
            };
        }

        case types.SURVEY_DETAILS_REQUEST: {
            return {
                ...state,
                details: {
                    ...state.details,
                    isLoading: true
                }
            };
        }

        case types.SURVEY_DETAILS_SUCCESS: {
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.payload,
                    isLoading: false,
                    error: null
                }
            };
        }

        case types.SURVEY_DETAILS_FAILURE: {
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.payload,
                    data: [],
                    isLoading: false
                }
            };
        }

        case types.SURVEY_SUBMIT: {
            return {
                ...state,
                list: {
                    ...state.list
                },
                details: {
                    ...state.details,
                },
                submittingSurvey: !state.submittingSurvey
            };
        }
        case types.SURVEY_NOTIFICATION: {
            return {
                ...state,
                surveyNotification: {
                    ...action.payload
                }
            }
        }
        default:
            return state;
    }
};

/* Get survey list */
export const getSurveyList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.SURVEY_LIST_REQUEST });
        try {
            const response = await getSurveyListApi();
            dispatch({
                type: types.SURVEY_LIST_SUCCESS,
                payload: { data: orderBy(response.data.Data, ['Sequence', 'SurveyId'], ['asc', 'asc']) }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.SURVEY_LIST_FAILURE));
        }
    };
};

/* Get selected survey details */
export const getSurveyDetails = (data, errorCallback) => {
    return async dispatch => {
        dispatch({ type: types.SURVEY_DETAILS_REQUEST });
        try {
            const response = await getSurveyDetailsApi(data);
            dispatch({
                type: types.SURVEY_DETAILS_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.SURVEY_DETAILS_FAILURE, true));
            errorCallback();
        }
    };
};

/* Submit survey */
export const submitSurvey = (data, callback) => {
    return async dispatch => {
        dispatch({ type: types.SURVEY_SUBMIT });
        try {
            await submitSurveyApi(data);
            dispatch({ type: types.SURVEY_SUBMIT });

            /* Show success message after the survey gets submitted */
            dispatch(showMsgFromJson(`common.alerts.success.surveySubmittedSuccess`, Constants.SUCCESS));

            /* After the success message take back to previous screen */
            callback();
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.SURVEY_SUBMIT, true));
            callback();
        }
    };
};

/* Get survey notification list */
export const getSurveyNotification = () => {
    return async (dispatch, getState) => {
        try {
            /* Check for survey notification config */
            if (getState().appSettings.isEnableSurveyRemainder) {
                const response = await getSurveyNotificationApi();
                dispatch({ type: types.SURVEY_NOTIFICATION, payload: { data: orderBy(response.data.Data, ['Sequence', 'SurveyId'], ['asc', 'asc']) } });
            }
        }
        catch (error) {
            dispatch({ type: types.SURVEY_NOTIFICATION, payload: { data: [] } });
        }
    };
};

/* Reset survey notification list */
export const resetSurveyNotification = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.SURVEY_NOTIFICATION, payload: { data: [] } });
    };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "") {
            dispatch({
                type: type,
                payload: { error: message }
            });
        }

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};